import Component from './RowCheckbox.component';

export default Component;
